<template>
    <div class="modal fade stick-up disable-scroll" id="captureAuthModal" tabindex="-1" role="dialog" aria-labelledby="captureAuthModalLabel" aria-hidden="false">
        <div class="modal-dialog ">
            <div class="modal-content-wrapper">
            <div v-if="cashing" class="modal-content">
                <div class="modal-header clearfix text-left">
                    <button type="button" class="close" data-dismiss="modal" aria-hidden="true">
                    <i class="pg-close fs-14"></i>
                    </button>
                    <h3>Capturer les autorisations</h3>
                </div>
                <div class="modal-body">
                    <p>
                        Êtes-vous certain de vouloir <strong>capturer</strong> les autorisations associées à l'encaissement 
                        <strong>#{{ cashing.id }}</strong>, d'un montant de <strong>{{ (cashing.ttc_amount / 100).toFixed(2) }}€</strong>, 
                        cette opération est irréversible ?
                    </p>

                    <hr>

                    <div>
                        <button type="button" class="btn btn-complete btn-cons no-margin inline"
                                @click="captureCashingAuthorizations(cashing.id)">Confirmer</button>
                        <button type="button" class="btn btn-default btn-cons no-margin inline"
                                data-dismiss="modal" @click="hideModal">Annuler</button>
                    </div>
                </div>
            </div>
            </div>
            <!-- /.modal-content -->
        </div>
        <!-- /.modal-dialog -->
    </div>
</template>

<script>
import {mapState, mapActions} from 'vuex'

export default {
    props: ['cashing'],

    methods: {
        ...mapActions('cash', ['captureAuthorizations']),

        showModal() {
            $('#captureAuthModal').modal()
        },
        
        hideModal() {
            $('#captureAuthModal').modal('hide')
        },

        captureCashingAuthorizations(cashingId) {
            this.captureAuthorizations(cashingId)
                .then(() => {
                    this.$emit('authorizations-captured', cashingId)
                })
        }
    }
}
</script>


// WEBPACK FOOTER //
// client/components/Cash/CaptureAuthModal.vue